import { createFileRoute, useParams } from '@tanstack/react-router';
import { fundingDetailSearchSchema } from '@/pages/ai-matching-results/lib/fundingDetailSearchSchema';
import { FundingDetailPageView } from '@/pages/ai-matching-results/ui/FundingDetailPageView';

const SpecialAllocationTaxSurveyFundingDetailPage = () => {
  const { documentId, recordId } = useParams({
    from: '/_protected/projects/ai-matching-results/special-allocation-tax-survey/$documentId/$recordId',
  });
  const search = Route.useSearch();
  return (
    <FundingDetailPageView
      category="special-allocation-tax-survey"
      documentId={documentId}
      recordId={recordId}
      search={search}
    />
  );
};

export const Route = createFileRoute(
  '/_protected/projects/ai-matching-results/special-allocation-tax-survey/$documentId/$recordId',
)({
  component: SpecialAllocationTaxSurveyFundingDetailPage,
  validateSearch: (search) => fundingDetailSearchSchema.parse(search),
});
